import {
  getEngageUrl,
  getCommunityUrl,
  getCommunityByPostUrl,
} from '~publish/components/CommentsSidebar/ChannelNav/helpers'
import type { PostCard_PostData } from '~publish/components/PostCard/PostCard'
import { useCommunityConfig } from '~publish/pages/Community/CommunityConfig'

/**
 * Custom hook to determine the correct engagement URL based on channel
 * availability in Community.
 *
 * @param channel - The channel fragment containing channel information
 * @param postId - Optional post ID for by-post view in Community
 * @returns The appropriate engagement URL (Community or Engage) or null if not available
 */
export const useGetEngagementUrl = (
  channel: PostCard_PostData['channel'],
  postId?: string,
): string | null => {
  const { config: commentsConfig } = useCommunityConfig()

  // If channel is supported in Community
  if (commentsConfig.isSupportedInComments(channel)) {
    // If a postId is provided, use the by-post URL
    if (postId) {
      return getCommunityByPostUrl(channel.id, postId)
    }

    // Return regular Community URL
    return getCommunityUrl(channel.id)
  }

  // If user doesn't have engage product, return null
  if (!channel.products?.includes('engage')) {
    return null
  }

  // Default to Engage URL
  return getEngageUrl(channel.id)
}
